import Otp from './otp.vue';

export default Otp;
